var types = {
    RESET_STORE: 'RESET_STORE',
    FETCH_ROOMS: 'FETCH_ROOMS',
    FETCH_ROOM: 'FETCH_ROOM',
    FETCH_ENRICHED_ROOM: 'FETCH_ENRICHED_ROOM',
    FETCH_UNREAD_CHATROOM_IDS: 'FETCH_UNREAD_CHATROOM_IDS',
    DELETE_ROOM: 'DELETE_ROOM',
    DELETE_ROOMS: 'DELETE_ROOMS',
    ARCHIVE_ROOM: 'ARCHIVE_ROOM',
    ARCHIVE_ROOMS: 'ARCHIVE_ROOMS',
    UNARCHIVE_ROOMS: 'UNARCHIVE_ROOMS',
    HANDLE_ROOM_ARCHIVED: 'HANDLE_ROOM_ARCHIVED',
    UNARCHIVE_ROOM: 'UNARCHIVE_ROOM',
    HANDLE_ROOM_UNARCHIVED: 'HANDLE_ROOM_UNARCHIVED',
    FETCH_ROOM_MESSAGES: 'FETCH_ROOM_MESSAGES',
    ADD_ROOMS: 'ADD_ROOMS',
    REMOVE_ROOM: 'REMOVE_ROOM',
    ADD_MESSAGE: 'ADD_MESSAGE',
    SEND_MESSAGE: 'SEND_MESSAGE',
    DELETE_MESSAGE: 'DELETE_MESSAGE',
    TYPING: 'TYPING',
    FETCH_MESSAGE_DRAFTS: 'FETCH_MESSAGE_DRAFTS',
    TYPING_STATUS_CHANGE: 'TYPING_STATUS_CHANGE',
    SET_MESSAGES_READ: 'SET_MESSAGES_READ',
    SET_MESSAGES_READ_FOR_SELF: 'SET_MESSAGES_READ_FOR_SELF',
    SET_ROOMS_MESSAGES_READ: 'SET_ROOMS_MESSAGES_READ',
    SET_LAST_MESSAGE_UNREAD: 'SET_LAST_MESSAGE_UNREAD',
    MARK_ROOMS_AS_READ: 'MARK_ROOMS_AS_READ',
    UPDATE_MESSAGES_INDICATIONS: 'UPDATE_MESSAGES_INDICATIONS',
    FETCH_PARTICIPANTS_DISPLAY_DATA: 'FETCH_PARTICIPANTS_DISPLAY_DATA',
    FETCH_DRILL_IN_MESSAGE_INDICATIONS: 'FETCH_DRILL_IN_MESSAGE_INDICATIONS',
    SET_UNSEEN_CHATROOMS: 'SET_UNSEEN_CHATROOMS',
    MARK_CHATROOM_SEEN: 'MARK_CHATROOM_SEEN',
    MARK_CHATROOMS_SEEN: 'MARK_CHATROOMS_SEEN',
    UPDATE_PRESENCE: 'UPDATE_PRESENCE',
    CLEAR_PRESENCE: 'CLEAR_PRESENCE',
    PRESENCE_CLEAR_STALE: 'PRESENCE_CLEAR_STALE',
};
export default types;
